export class FormType {
  ndc: string;
  strength: string;
    awpUnitPrice: number;
    packageSize: number;
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/medispan/models/form-type.ts